<template>
<div class="step-con">
  <div class="infor-headerBg">
    <div class="infor-header layout">
      <a href="#" class="logo"></a>
      <div class="ltxt">医学教育网在线模拟考试系统</div>
    </div>
  </div>
  <div class="rulemain layout clearfix">
    <div class="ruleBox">
      <div class="conBox clearfix">
        <div class="conBox-tit">考试规则</div>
        <div class="conBox-txt">1.考生只准携带必要的考试文具进入考场（如2B铅笔、蓝色或黑色钢笔、签字笔等）。严禁携带书籍、资料、包等物品，以及具有发送或者接收信息功能的设备（如手机等）进入考场，如有违反，将按照作弊处理。</div>
        <div class="conBox-txt">2.开考30分钟后考生不得进入考室。考试期间考生不得离开考室，在考试规定时间前完成答题或要求提前结束考试的考生，须按考试工作人员要求，在警戒线区域内指定地点等待，考试结束后方能离开。等待期间不得使用通讯工具。</div>
        <div class="conBox-txt">3.考生不得要求监考员解释试题，如遇计算机系统问题，可举手询问。外籍或台湾、香港、澳门考生进入考场后，必须使用中文普通话。</div>
        <div class="conBox-txt">4.考生在考场内必须保持安静，不准交头接耳、左顾右盼；不准偷窥；不准吸烟。</div>
        <div class="conBox-txt">5.考生应自觉服从监考员管理，不得以任何理由妨碍监考员进行正常工作。对违反《考试规则》、考试纪律，不服从监考员管理的违规考生，将依据《<em id="examName">护士资格</em>考试违纪违规处理规定》进行处理。</div>
      </div>
      <a href="javascript:void(0)" @click="gotoNext" class="bbtn">确认规则</a>
    </div>
  </div>
  <CommonFooter />
</div>
</template>

<script>
import {CommonFooter} from "../../components/common";

export default {
  name: "step1",
  components:{
    CommonFooter
  },
  methods:{
    gotoNext(){
      const { courseID,centerID,siteCourseID,saveBizID } = this.$route.query
      this.$router.push({
        path:'step3',
        query:{
          courseID:courseID,
          centerID:centerID,
          siteCourseID:siteCourseID,
          saveBizID:saveBizID
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
